import { MediaResolver, ResolvedMedia, ResolverContext } from '../types';
import { getPathname, hasHlsExtension, isHlsContentType } from '../utils/contentType';

export class HlsResolver implements MediaResolver {
  name = 'HlsResolver';

  async canResolve(context: ResolverContext): Promise<boolean> {
    const { url } = context.input;
    const pathname = getPathname(url);

    if (hasHlsExtension(pathname) || hasHlsExtension(url)) {
      return true;
    }

    try {
      const content = await context.fetchContent(url);

      return isHlsContentType(content.contentType);
    } catch {
      return hasHlsExtension(pathname);
    }
  }

  async resolve(context: ResolverContext): Promise<ResolvedMedia | null> {
    const { url, thumbnailUrl, title, description } = context.input;

    return {
      mediaType: 'video',
      playerType: 'html5',
      playbackUrl: url,
      thumbnailUrl: thumbnailUrl ?? undefined,
      title: title ?? undefined,
      description: description ?? undefined,
      resolved: true,
      resolverName: this.name,
      metadata: {
        streamFormat: 'hls',
      },
    };
  }
}
